import React from "react";
import { Localize } from "components/service";
import { TStand } from "../helpers/stand-types-helper";
import Icons from "components/icons";

interface IStand3dModelMetaFieldProps
{
  stand: TStand;
  icon?: boolean;
}

const Stand3dModelMetaField: React.FC<IStand3dModelMetaFieldProps> = ({
  stand,
  icon = false
}) =>
{

  const modelMeta = stand.meta_fields?.find(
    (m) =>
      m.meta_key === "additional_stand_type_fields_3d_model" &&
      m.meta_group === "3d_models"
  );

  const modelUrl = modelMeta?.meta_value ?
    (icon ? <span className="model-3d"><Icons.Model /></span> : <span className="primary-color fw-600"><Localize>GLOBAL.Text_LinkUploaded</Localize></span>) :
    <strong>&mdash;</strong>;

  return modelUrl;
};

export default Stand3dModelMetaField;
